export default class DateRangePicker {
    constructor() {
        this.selector = '[data-daterange]';
        this.init();
    }

    init() {
        var self = this;
        flatpickr.localize( flatpickr.l10ns[ themeVars.language ] );

        console.log(themeVars.language);

        $( self.selector ).each( function() {
            var $el = $( this ),
                $from = $el.find( '[data-daterange-from]' ),
                $to = $el.find( '[data-daterange-to]' );

            $from.flatpickr( {
                minDate: "today",
                disableMobile: "true",
                dateFormat: "d. m. Y",
                "plugins": [ new rangePlugin( {
                    input: $to[ 0 ]
                } ) ]
            } );
        } );
    }
}